/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Aoun Naqvi",
  title: "Hi all, I'm Aoun",
  subTitle: emoji(
    "A passionate Full Stack WordPress Developer 🚀 having 10+ years of experience building Web applications with PHP / JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1PsNnMjjvTWdMSjhuU-SdIddvzaw3YdJc/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aounnaqvi",
  linkedin: "https://www.linkedin.com/in/aounnaqvi4/",
  gmail: "imaounnaqvi@gmail.com",
  gitlab: "",
  facebook: "https://www.facebook.com/aounnaqvi512",
  medium: "",
  stackoverflow: "https://stackoverflow.com/users/3962624/aoun-abbas",
  instagram: "https://www.instagram.com/aounnaqvi4",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Passionate Full Stack Developer on a Quest to Explore and Master Every Tech Stack",
  skills: [
    emoji(
      "⚡ Developing dynamic and highly engaging front-end experiences tailored for web applications and responsive mobile-friendly interfaces"
    ),
    emoji("⚡ Specializing in single-page applications (SPA) and customized WordPress development"),
    emoji(
      "⚡ Integrating essential third-party WordPress plugins and tools to enhance site performance, functionality, and scalability"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Sargodha University",
      logo: require("./assets/images/uos_footer_logo.png"),
      subHeader: "Bachelor of Science in Software Engineering",
      duration: "September 2012 - April 2016",
      desc: "Participated in the research of Virtual Machine Migration in Cloud Computing.",
      descBullets: [
        "Learnt Programming Fundamentals / OOP in C++",
        "Learnt the fundamentals of Quality Assurance, Software Testing, Project Management"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full-Stack WordPress Developer",
      company: "Crypthon Lab",
      companylogo: require("./assets/images/crypthonlab_logo.jpeg"),
      date: "September 2024 – Present"
    },
    {
      role: "Web Developer",
      company: "Elite Digital",
      companylogo: require("./assets/images/elitedigital_logo.jpeg"),
      date: "August 2017 – August 2024"
    },
    {
      role: "Senior WordPress Developer",
      company: "Remote Experts",
      companylogo: require("./assets/images/remoteexperts_logo.jpeg"),
      date: "August 2021 – August 2022"
    },
    {
      role: "PHP Freelancer",
      company: "Fiverr",
      companylogo: require("./assets/images/fiverr_com_logo.jpeg"),
      date: "Jan 2015 – Sep 2019"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/Screenshot_12.jpg"),
      projectName: "Textify Now",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://textifynow.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Screenshot_13.jpg"),
      projectName: "LiveLike",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://livelike.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_14.jpg"),
      projectName: "Elite Digital Agency Blog",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://elitedigitalagency.com/blog/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_15.jpg"),
      projectName: "Practice Perfect",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://practiceperfectemr.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_16.jpg"),
      projectName: "ArmourX",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://armourxsafety.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_17.jpg"),
      projectName: "Schoolhouse Products Inc",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.schoolhouseproducts.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_18.jpg"),
      projectName: "Bloom By Organon",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bloombyorganon.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_19.jpg"),
      projectName: "Unite Communications",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://unite.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_20.jpg"),
      projectName: "Heart Safe",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://heartsafe.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_21.jpg"),
      projectName: "Lextec",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://lextec.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_22.jpg"),
      projectName: "Rent a Son",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://rentason.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_23.jpg"),
      projectName: "Pace Law",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://pacelawfirm.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_24.jpg"),
      projectName: "Viva Life",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://vivalife.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_25.jpg"),
      projectName: "Solmar",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://solmar.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_26.jpg"),
      projectName: "Decorium",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://decorium.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_27.jpg"),
      projectName: "Gold View",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://goldview.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_28.jpg"),
      projectName: "Jolly Snacks",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://jollysnacks.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_29.jpg"),
      projectName: "Emma Kaufmann Camp",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://emmakaufmanncamp.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_30.jpg"),
      projectName: "Provisus",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.provisus.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_31.jpg"),
      projectName: "Windsor Arms",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://windsorarmshotel.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_32.jpg"),
      projectName: "Nikhanda",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://nikhanda.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_33.jpg"),
      projectName: "Organon",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.organon.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_34.jpg"),
      projectName: "Harmony by Organon",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://harmonyorganon.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_35.jpg"),
      projectName: "ON Xpress",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://onxpress.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_36.jpg"),
      projectName: "jDass",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://dass.ca/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_37.jpg"),
      projectName: "Perfect Trains",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.perfecttrains.com/"
        }
      ]
    },
    {
      image: require("./assets/images/Screenshot_38.jpg"),
      projectName: "Grandeur",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://gowithplus.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3047924992",
  email_address: "imaounnaqvi@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
